<template>

<div class="dropDown">

  <div @click="showContentAlarm = !showContentAlarm" class="top-row">
  <span class="title">{{data.title}}</span>
  <div class="arrow">
    <span class="date" v-if="data.createdAtDateTime">{{$G2J(data.createdAtDateTime)}}</span>
    <img src="../../assets/icon/bottom-arrow.png" alt="">
  </div>
  </div>
  <p v-if="showContentAlarm === true" class="content">{{data.content}}</p>
</div>
</template>

<script>
export default {
  name: "the-drop-down",
  props:['data'],
  data(){
    return{
      notfications: [
        {
          title: 'پیام شما در رایچت پاسخ داده شده',
          date: '00/12/03 | 14:33',
          content: 'لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود.'
        },
        {
          title: 'پیام شما در رایچت پاسخ داده شده',
          date: '00/12/03 | 14:33',
          content: 'لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود.'
        },
        {
          title: 'پیام شما در رایچت پاسخ داده شده',
          date: '00/12/03 | 14:33',
          content: 'لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود.'
        },
        {
          title: 'پیام شما در رایچت پاسخ داده شده',
          date: '00/12/03 | 14:33',
          content: 'لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود.'
        },
        {
          title: 'پیام شما در رایچت پاسخ داده شده',
          date: '00/12/03 | 14:33',
          content: 'لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود.'
        },
      ],
      showContentAlarm:false,
      methods:{
        getNotifs(){

      consolse.log(data)
        }


      },
    mounted() {
      this.getNotifs()
    }
    }
  }

}
</script>

<style lang="scss" scoped>
.dropDown{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
  box-shadow: 0 4px 24px -1px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding: 30px;
  direction: rtl;
  backdrop-filter: blur(40px);
  cursor: pointer;
  margin-bottom: 24px;
  gap: 20px;

  .top-row{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }

  .content{
    width: 100%;
    text-align: right;
    color: #FBFBFD;
    font-size: clamp(12px , 2vw , 14px);
  }

  .title{
    font-size: clamp(12px , 2vw , 14px);
    color: #FBFBFD;
  }

  .arrow{
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    cursor: pointer;

    img{
      width: 10px;
      height: 8px;
    }
  }

  .date{
    font-size: clamp(12px , 2vw , 14px);
    color: #D7C8C8;
  }
}
</style>